import {
  calculateTax as publicCalculateTax,
  listTaxCalculators as publicListTaxCalculators,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const calculateTax: MaybeContext<
  BuildRESTFunction<typeof publicCalculateTax> & typeof publicCalculateTax
> = /*#__PURE__*/ createRESTModule(publicCalculateTax);
export const listTaxCalculators: MaybeContext<
  BuildRESTFunction<typeof publicListTaxCalculators> &
    typeof publicListTaxCalculators
> = /*#__PURE__*/ createRESTModule(publicListTaxCalculators);

export {
  ExemptBy,
  JurisdictionType,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
export {
  TaxCalculationGateway,
  CalculateTaxRequest,
  Address,
  LineItem,
  AddressIndex,
  AddressIndexAddressIndexOptionsOneOf,
  MultipleAddresses,
  ExemptCalculationDetails,
  ExemptCalculationDetailsExemptByOptionsOneOf,
  CalculateTaxResponse,
  TaxSummary,
  AggregatedTaxBreakdown,
  LineItemTaxDetails,
  TaxBreakdown,
  LineItemTaxSummary,
  ApplicationError,
  ListTaxCalculatorsRequest,
  ListTaxCalculatorsResponse,
  TaxCalculatorDetails,
  AggregateTaxBreakdownsRequest,
  AggregateTaxBreakdownsResponse,
  CalculateTaxOptions,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
export {
  ExemptByWithLiterals,
  JurisdictionTypeWithLiterals,
  CalculateTaxApplicationErrors,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';
